<form class="mx-auto col-md-3 mt-2" [formGroup]="createUserCommandRequestForm" (ngSubmit)="createUser()">
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Create an account</h5>
      <hr />
      <formly-form [form]="createUserCommandRequestForm" [fields]="createUserCommandRequestFields"
        [model]="createUserCommandRequest">
        <div class="form-group text-right">
          <button class="btn btn-primary" type="submit">Create</button>
        </div>
      </formly-form>
    </div>
  </div>
</form>